const ORIGIN = {
  standard: "standard", // App Mobile usuario final
  rrppSell: "rrppsell", // App Mobile cuando vende relaciones publicas
  producer: "producer", // App Mobile cuando vende el productor
  producerBO: "producer-bo", // Back Office cuando vende el productor.
  gift: "gift-bo", // Regalos
  loyaly: "loyaly", // Loyaly
};

const STATUS = {
  blocked:"blocked",
  active:"active"
}

const DUMMY_EVENT_DNI = "99999999"



module.exports = { ORIGIN:ORIGIN, DUMMY_EVENT_DNI:DUMMY_EVENT_DNI, STATUS:STATUS };



// WEBPACK FOOTER //
// ./src/common/Constants.js